export default {
  phone: '电话',
  email: '邮箱',
  enterpriseWeChat: '企业微信号',
  ConsultationQrCode: '咨询二维码',
  items: ['1e','2','3', '4','5'],
  navBar: {
   home: '首页',
   groupOverview: '集团概况',
   companyOverview: '公司概况',
   coreValue: '核心价值',
   subCompany: '分支结构',
   businessScope: '业务范畴',
   featureService: '特色服务',
   internationalShipping: '国际海运',
   internationalAir: '国际空运',
   internationalTruck: '国际卡航',
   huanshuntongTechnology: '环顺通科技',
   digitalPlatform: '产品数字化平台',
   interactivePlatform: '客户交互式平台',
   visualPlatform: '物流可视化平台',
   newsCenter: '新闻中心',
   newsDetail: '新闻详情',
   humanResource: '人力资源',
   talentConcept: '人才理念',
   joinUs: '加入环顺通',
   contactUs: '联系我们',
   contactCompany: '集团联系',
   contactPort: '口岸联系',
  },
  homePage: {
    bannerTitle: '环顺通供应链',
    bannerText: '您的理想物流合作伙伴，提供端到端的数字货代平台',
    groupIntro: '集团介绍',
    groupIntroText: '环顺通供应链始于2018年，以一站式、一揽子、一条龙的特色运营，提供提供安全、稳定、快捷的国际物流服务，助力中国制造智达全球；环顺通渠道产品网络覆盖美国、欧盟、英国、加拿大、墨西哥、日本、澳洲等主要电商贸易国家和地区，强有力的海外团队确保目的港清关配送服务顺畅，提供安全、稳定的海陆空全时效覆盖的多式联运物流解决方案。',
    serviceIntro: '业务介绍',
    meitongAir: '环顺通空运',
    meitongShip: '环顺通海运',
    meitingTruck: '环顺通卡航',
    meitongStorage: '海外仓',
    newsCenter: '新闻中心',
    moreNews: '更多新闻',
  },
  companyPage: {
    groupIntro: '集团介绍',
    introText: "环顺通(HST)始于2018年，以一站式、一揽子、一条龙的特色运营，提供提供安全、稳定、快捷的国际物流服务，助力中国制造智达全球。<br/>环顺通渠道产品网络覆盖美国、欧盟、英国、加拿大、墨西哥、日本、澳洲等主要电商贸易国家和地区，强有力的海外团队确保目的港清关配送服务顺畅，提供安全、稳定的海陆空全时效覆盖的多式联运物流解决方案。<br/>环顺通于2023年7月成为信用中国“重点信用认证企业”，2023年8月入选了亚马逊服务提供商网络(Amazon SPN)，2024年2月成为亚马逊ShipTrack服务商，2024年3月成为亚马逊 TSPN服务商、SEND物流承运商，2020-2024年连续四届获得晓生排行榜“FBA物流十强企业”，2023年10月荣获亚马逊“2023金牌辅助”与“SPN一年级奖”等荣誉，2024年2月获得雨果跨境“2023最佳跨境物流奖”，2024年9月荣获物博会“优秀FBA物流服务商”，2024年12月荣获中国跨境电商物流“十大头程物流服务商”等荣誉。<br/>环顺通总部位于深圳，办公面积7000多平方米，国内在广州、中山、佛山、东莞、上海、义乌、郑州、青岛、长沙、合肥、宁波、厦门、成都、杭州、新疆等地设立20家分公司，海外在加拿大、美国、墨西哥、英国、比利时、德国、法国、日本、白俄罗斯、越南、哈萨克斯坦等地设立20家分公司，全球员工超1000人。环顺通自营线路80多条，国内仓储面积60000多平方米，自营海外仓面积50000多平方米，强大的基础配置与专业团队为多样化物流配送需求提供了保证。<br/>环顺通专注跨境电商物流10年，不断完善国内销售网络，扩大产品线覆盖目的国，正着重实现核心市场运营服务完成闭环，信息化向数字化转型，关键运营的控制点基本实现可控和可视化，以成为行业领先的跨境电商物流企业。",
    feature1: '一站式',
    feature2: '一揽子',
    feature3: '一条龙',
    rightTitle: '一站式',
    rightText: '设立多个分子公司为全国各地客户进行本地化服务'
  },
  coreValuePage: {
    coreValue: '核心价值',
    whishGoal: '企业愿景及目标',
    whish: '企业愿景',
    whishText: '跨境电商全球物流优选平台，帮助中国制造安全、稳定、快捷地智达全球',
    goal: '五年目标',
    goalText: '助力跨境电商五万家企业成功出海',
    concept: '核心价值观',
    concept1: '开放协同',
    concept2: '团结奋斗',
    concept3: '诚实守信',
    concept4: '开拓创新',
  },
  featureBranchPage: {
    branchTitle: '分支结构',
    branch: [
      {
        name: '深圳总部',
        address: '深圳市龙岗区坂田五和大道南路49号金方华电商产业园9栋105深圳市龙岗区雅园路26号坂银谷A1001-A1004'
      },
      {
        name: '机场分部',
        address: '深圳市宝安区福永街道怀德国际大厦1501-04-A1004'
      },
      {
        name: '观澜分部',
        address: '深圳市龙华区观澜街道牛湖社区观天路17号大地城红木市场'
      },
      {
        name: '广州分公司',
        address: '广州市白云区彭上科技产业园F座202-206'
      },
      {
        name: '中山分公司',
        address: '中山东区利和国际金融中心4701-03'
      },
      {
        name: '佛山分公司',
        address: '佛山市顺德区顺联智造汇18座首层118-125号铺'
      },
      {
        name: '东莞分公司',
        address: '东莞市南城街道寰宇汇金中心9栋A座3503室'
      },
      {
        name: '上海分公司',
        address: '上海市松江区寅西路358号A栋606-607室'
      },
      {
        name: '义乌分公司',
        address: '浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（环顺通(HST)）'
      },
      {
        name: '郑州分公司',
        address: '郑州市管城回族区文治路20号云时代广场2-368室'
      },
      {
        name: '青岛分公司',
        address: '浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（环顺通(HST)）'
      },
      {
        name: '合肥分公司',
        address: '郑州市管城回族区文治路20号云时代广场2-368室'
      },
      {
        name: '宁波分公司',
        address: '浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（环顺通(HST)）'
      },
      {
        name: '长沙分公司',
        address: '郑州市管城回族区文治路20号云时代广场2-368室'
      },
      {
        name: '厦门分公司',
        address: '浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（环顺通(HST)）'
      },
      {
        name: '成都分公司',
        address: '郑州市管城回族区文治路20号云时代广场2-368室'
      },
    ],
  },
  featureServicePage: {
    featureTitle: '特色服务',
    feature1: {
      title: '多样',
      text: '各项多元化特色服务，满足多方需求'
    },
    feature2: {
      title: '专业',
      text: '专业团队支持，安心可靠'
    },
    feature3: {
      title: '服务',
      text: '热情，忠诚，为您提供最优质的服务'
    },
    description1: {
      title: '柬埔寨双清',
      text: '中国口岸运往柬埔寨货物，可提供金边港双清服务。第一期产品,瓷砖的金边双清服务，适用发货地，青岛、广东、厦门。'
    },
    description2: {
      title: '马来西亚转口贸易',
      text: '中国任一港口（天津、青岛、上海、宁波、深圳、广州港等）起运，经马来西亚清关、倒箱、换船、转运美国服务。涉及买卖双方需要知情，做好相关信用证条款，使用中性包装，转运时办理第三国产地证明。'
    },
    description3: {
      title: '海外仓',
      text: '中国各大口岸出口至菲律宾的货物，提供双清业务，涉及产品广，覆盖日用品、杂货、机电设备等广泛领域。'
    },
    description4: {
      title: '项目物流&特种箱',
      text: '1. 超大件货物的全程国际物流(包括国内外整厂搬迁) 2. 中小型设备可以用特种集装箱运输 3. 进出口大宗散杂货物运输及租船业务 4. 进出口危险品货物集装海洋运输 5. 集装箱货物进口'
    },
    description5: {
      title: '印度延伸服务',
      text: '以印度西海岸那瓦西瓦和东海岸金奈为支点，我司提供遍布印度全境的优质服务。我司的服务覆盖印度安德拉邦、阿萨姆邦、比哈尔邦、果阿邦、古吉拉特邦、哈里亚那邦、喜马偕尔邦、卡纳塔克邦、喀拉拉邦、中央邦、马哈拉斯特拉邦、曼普尔邦、梅加拉亚邦、米佐拉姆邦、那加兰邦、奥里萨邦、旁遮普邦、拉贾斯坦邦、泰米尔纳德邦、特里普拉邦、北方邦、西孟加拉邦'
    },
    description6: {
      title: '再生塑料跨境物流',
      text: '塑料废品再生造粒的贸易中，涉及的三方企业在整个交易行为中需要专业的物流公司为其提供优质服务。环顺通(HST)物流马来西亚子公司，不仅可以操作马来废料进口，成料出口整个跨境物流，对找不到具有再生加工资质企业的客户，还可以提供在马来西亚的进口Permit等相关进口文件的服务，从根本上解决贸易三方的痛点。'
    },
  },
  internationShippingPage: {
    featureTitle: '国际海运',
    featureText: '我们与世界顶级航运公司合作，为客户提供有竞争力的价格和充足的舱位，确保您的货物按计划顺利到达',
    feature1: {
      title: '效率高',
      text: '我们使用最先进的技术来协调贸易复杂性，减少所花费的时间、金钱和精力。'
    },
    feature2: {
      title: '费用低',
      text: '我们提供详细透明的海运报价，不会存在隐藏费用。'
    },
    feature3: {
      title: '可视化',
      text: '使用我们的跟踪系统监控您的货件，界面直观，可视化的货运跟踪服务让您更安心。'
    },
    description1: {
      title: '美线整箱进出口，环顺通拼箱',
      text: '我们有先进的一站式平台、优势的价格、充足的舱位，且专业的美线团队，同时专注欧美航线，全方面为您提供优质的服务。并承接海运拼箱进出口业务，代理网络发达。一手的拼箱价格，专业的内陆衔接服务。'
    },
    description2: {
      title: '货运稳定可靠',
      text: '我们将根据您要求的运输时间，为您提供来自各运输公司的最适航班，以确保您能够在重要的时间内按时交货。'
    },
  },
  internationAirPage: {
    featureTitle: '国际空运',
    featureText: '我们与各优秀航空公司及货运代理商合作，通过强大的平台提供优惠简便的空运服务，同时也提供量身定制的货运服务，以满足客户的各种需求。',
    feature1: {
      title: '实时监控',
      text: '我们通过专有的技术全天候监控您的货物，确保准时并安全到达目的地。'
    },
    feature2: {
      title: '价格优势',
      text: '有竞争力的价格，并且提供优化整合，降低成本。'
    },
    feature3: {
      title: '定制化服务',
      text: '我们拥有专业的团队为您定制个性化货流方案，以满足您的需求，帮您省时省力省钱。'
    },
    description1: {
      title: '环顺通空运',
      text: '专注欧美和东南亚航线，承接空运进出口业务，空港网点覆盖全面，自有品牌，自有仓库。KE直飞美国精品航线，CI美国全程空接空，CZ包板BSA。'
    },
    description2: {
      title: '强大的供应商网络',
      text: '我们的空运专家团队能够及时处理各类型的货物，配合强大的全球领先供应商网络，确保您享受最便捷安心的进出口空运服务。'
    },
  },
  internationTruckPage: {
    featureTitle: '中欧卡航',
    featureText: '通过平台同步跟踪功能和全面的优质卡车合作商网络，我们可以最大限度地保证您的货物安全、准时到达目的地。',
    feature1: {
      title: '货运平台',
      text: '卡车司机可以直接在平台上获取货物信息，实时更新交货进度，并在必要时直接联系客户。'
    },
    feature2: {
      title: '运价透明',
      text: '传统服务模式的卡车运输成本相对繁琐。 我们的平台展示了所有成本，便于比较报价单和发票上的价格，节省您的时间和精力。'
    },
    feature3: {
      title: '物流可视化',
      text: '我们能够为您提供实时信息，确保货物按时交付。使用safround平台将使您的仓库团队更轻松地工作。'
    },
    description1: {
      title: '东南亚全境卡车',
      text: '我们提供两条线路，完成货物在东南亚的卡车运输。 线路1：中国（NGB，SHA，SZ，HK）—越南（河内）— 老挝 — 泰国（曼谷）— 马来西亚（吉隆坡）— 新加坡 线路2：中国（NGB，SHA，SZ，GX）— 越南（河内）— 越南（胡志明）— 柬埔寨（金边）'
    },
    description2: {
      title: '货运稳定可靠',
      text: '环顺通与所有主要航运公司和NVOCC合作，为您的货物提供最可靠的海运服务。透明的报价，前期获取详细的海运报价以及目的地费用，如码头处理费，港口费，结算费，文件备案费。'
    },
  },
  digitalPlatformPage: {
    bannerTitle: '产品数字化平台',
    bannerText: '易优达作为环顺通(HST)投资创立的互联网货代自营平台，于2017年4月正式上线，总部位于宁波，在深圳、厦门、上海、嘉兴、青岛、大连、天津、东南亚等地均设有分公司。平台设有在线查询、在线订舱、货物可视化跟踪等服务功能，旨在为全国货代同行提供遍布全国和东南亚各大口岸的自营优势航线产品和服务，搭建一条快捷的全程可视化物流服务通道。',
    feature1: {
      title: '效率',
      text: '按需求查找，快速精准获取'
    },
    feature2: {
      title: '信息全',
      text: '功能多，信息齐，各项业务均可查询'
    },
    feature3: {
      title: '可视化',
      text: '掌控过程，一切货物尽在追踪'
    },
    description1: {
      title: '先进物流专家',
      text: '化繁为简，一键查询，海运、陆运、空运专业团队，实时更新，海量产品在线订舱，易优达将智能技术融入传统，实现物流可视化，逐力打造国际供应链新风潮。'
    },
    description2: {
      title: '做您需要的易优达',
      text: '易优达平台以北美航线为核心产品 ( 远东出口北美货量《JOC》排名全球NVOCC位列22名)，并同时涵盖美国出口跨境电商物流、非美航线、空运、铁路等全方位货代产品，以自营互联网货代的模式为全国货代同行在全国各大港口同时提供高效、高质量的服务。'
    },
  },
  interactivePlatformPage: {
    bannerTitle: '客户交互式平台',
    bannerText: '交流是信息互换的过程，我们运用科技创造客户交互式平台，<br/>让交流体现在每一个流程。',
    feature1: {
      title: '省时省力',
      text: '打破传统，告别繁复切换'
    },
    feature2: {
      title: '针对性',
      text: '以物流节点为前提，交流过程清晰可见'
    },
    feature3: {
      title: '个性化',
      text: '独特页面，为沟通创造新条件'
    },
    description1: {
      title: '客户交互创新',
      text: '合作的每一个节点都可以成为我们相互交流的背景，我们以更优的沟通方式建立客户交互式平台，无需通过邮件短讯来互相询问通知，运用技术结合物流可视与交流， 告别信息复杂紊乱。'
    },
    description2: {
      title: '全新交互体验',
      text: '以实现辅助和自助服务相结合的人性化互动和全渠道交互为目标，让您体验智能的交流互动，从询价到订单，忠于服务客户。'
    },
  },
  visualPlatformPage: {
    bannerTitle: '物流可视化平台',
    bannerText: '物流可视化平台作为提供货物追踪管理等功能的信息化平台，高效链接多方合作及其上下游，实现物流作业执行监控及供应链可视化，极大的满足了客户对于现代物流发展的需求。',
    feature1: {
      title: '便捷',
      text: '一查即有，告别等待'
    },
    feature2: {
      title: '准确',
      text: '可靠的信息来源'
    },
    feature3: {
      title: '实时性',
      text: '第一时间及时更新'
    },
    description1: {
      title: '物流配送的可视化',
      text: '长期以来以传统的手工、邮件方式进行下单，包括在途反馈，效率低，出错高。环顺通为您专业打造先进的物流可视化平台，实时掌控节点信息，随时随地了解货物运输进程，提升服务品质，便于您在线查询货物动态，提高客户满意度。'
    },
    description2: {
      title: '您的供应链“雷达”',
      text: '辐射全球千余港口，货物动态节点，全过程可控，实时追踪，定位船舶动态，解决人工影响信息交互的延迟，方便您快捷操作，促进货物与客户互联互通。'
    },
  },
  contactPortPage: {
    bannerTitle: '货运口岸',
    port: [
      {
        city: '宁波',
        address: '地点：宁波市鄞州区宁穿路1222号宏泰帝标写字楼17层'
      },
      {
        city: '上海',
        address: '地点：上海市杨浦区国安路386号612-619室'
      },
      {
        city: '嘉兴',
        address: '地点：浙江省嘉兴市南湖区建瑞大厦A幢1901室'
      },
      {
        city: '南京',
        address: '地点：江苏省南京市汉中路89号金鹰商场A座4102室'
      },
      {
        city: '青岛',
        address: '地点：青岛市南区山东路6号华润大厦B座1206-08室'
      },
      {
        city: '天津',
        address: '地点：天津市和平区大沽北路2号天津环球金融中心津塔写字楼4805室'
      },
      {
        city: '深圳',
        address: '地点：深圳市福田区福中三路1006号诺德中心三楼F-G-H单元'
      },
      {
        city: '厦门',
        address: '地点：中国(福建)自由贸易试验区厦门片区象屿路97号厦门国际航运中心D栋701室'
      },
      {
        city: '马来',
        address: '地点：NO.28 (3RD FLOOR) JALAN TIARA 2A/KU1, BANDAR BARU KLANG, 41150 KLANG, SELANGOR, MALAYSIA'
      },
      {
        city: '越南',
        address: '地点：207 NGUYEN VAN TROI STREET, WARD 10, PHU NHUAN DISTRICT, HO CHI MINH CITY, VIETNAM'
      },
      {
        city: '柬埔寨',
        address: '地点：5F Vanda Tower, Block 79, Kampucheakrom Blvd,Sangkat Monorom, 7 Makara District,Phnom Penh, Cambodia.'
      },
      {
        city: '泰国',
        address: '地点：26/56 TPI Tower Bldg, 21th Floor Nang Lin Chi Rd, Thungmahamek,Sathorn, BKK 10120'
      },
    ]
  },
  newsCenterPage: {
    newsCenter: '新闻中心',
    huanshuntongNews: '环顺通新闻',
    back: '返回'
  },
  talentConceptPage: {
    bannerTitle: '环顺通有逆',
    bannerText: '虚位以待，我们期待你的加入',
    bannerBtn: '查看职位',
    moduleTitle: '人才理念',
    moduleText: '人才理念是企业重视人才、爱护人才、合理开发人才、使用人才、留住人才、提升人才的指导思想和价值观念。 优秀的人才是实现企业战略目标的基础，是企业持续发展的动力。公司以科学的人才培养方法、有效的激励机制、公平的竞争平台、广阔的事业发展空间广纳良才，在人力资源“选、育、用、留”方面加大力度，不断优化人员素质结构。让每一位员工都能在集体中充分体现自我价值，达到个人生涯规划与企业发展目标的最大契合，员工与企业共同的成长。',
    featureTitle1: '德才兼备',
    featureText1: '才者，德之资也;德者，才之帅也。“德”一具备较高的基本素质，“才”--履行岗位职责的基本能力。古人云:尺有所短，寸有所长，物有所不足，智有所不明。选人用人，不求兼备，但以德为先,以德促才，以才育德。通过提高企业人才素质，构建德才兼备的人才结构。',
    featureTitle2: '人尽其才',
    featureText2: '人有长短不分大小，德才兼顾，内外兼收。知人善任，人!其才。慧眼识才，热心爱才，气度用才胆略举胸怀容才。深入发掘每个员工身上的闪光点，充分发挥每个员工的长处，最大限度的整合企业的才资源，为企业的持续发展提供强劲的动力，推动企业步入健康发展的快车道。',
    readTitle: '准备好加入环顺通了吗？',
    viewAllJob: '查看所有职位',
  },
  joinUsPage: {
    bannerTitle: '招才纳贤',
    bannerInput: '岗位名称/工作地点/学历要求',
    bannerBtn: '查看职位',
    applyBtn: '申请职位'
  },
  contactCompanyPage: {
    bannerTitle: '集团联系',
    contactWay1: {
      name: '媒体联络',
    },
    contactWay2: {
      name: '法务联络',
    },
    contactWay3: {
      name: '商务合作',
    },
  }
}